"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useGamepadScale = exports.useScreenScale = exports.useScale = exports.useNormalize = exports.normalizeVertical = exports.normalize = exports.moderateVerticalScale = exports.moderateScale = exports.GamepadFontScale = exports.GamepadScale = exports.UnboaredScale = void 0;
const react_1 = require("react");
const utils_storage_1 = require("@unboared/utils.storage");
const react_native_size_matters_1 = require("react-native-size-matters");
exports.UnboaredScale = {
    screen: 1.0,
    screenFont: 1.0,
    gamepad: 1.8,
    gamepadFont: 1.8,
};
exports.GamepadScale = exports.UnboaredScale.gamepad;
exports.GamepadFontScale = exports.UnboaredScale.gamepadFont;
const moderateScale = (px, scale = exports.UnboaredScale.screen, factor) => {
    return scale * (0, react_native_size_matters_1.moderateScale)(px, factor);
};
exports.moderateScale = moderateScale;
const moderateVerticalScale = (px, scale = exports.UnboaredScale.screen, factor) => {
    return scale * (0, react_native_size_matters_1.moderateVerticalScale)(px, factor);
};
exports.moderateVerticalScale = moderateVerticalScale;
/* For screen */
const normalize = (px, scale = exports.UnboaredScale.screen) => {
    return (0, exports.moderateScale)(px, scale, 0.5);
};
exports.normalize = normalize;
const normalizeVertical = (px, scale = exports.UnboaredScale.screen) => {
    return (0, exports.moderateVerticalScale)(px, scale, 0.5);
};
exports.normalizeVertical = normalizeVertical;
const useNormalize = () => {
    const { scale, fontScale } = (0, exports.useScale)();
    return {
        normalize: (px) => (0, exports.normalize)(px, scale),
        normalizeVertical: (px) => (0, exports.normalizeVertical)(px, scale),
        normalizeFont: (px) => (0, exports.normalize)(px, fontScale),
        moderateScale: (px, factor) => (0, exports.moderateScale)(px, scale, factor),
        moderateFontScale: (px, factor) => (0, exports.moderateScale)(px, fontScale, factor),
        moderateVerticalScale: (px, factor) => (0, exports.moderateVerticalScale)(px, scale, factor),
    };
};
exports.useNormalize = useNormalize;
exports.useScale = (0, utils_storage_1.createGlobalStorage)((set, get) => ({
    scale: exports.UnboaredScale.screen,
    fontScale: exports.UnboaredScale.screen,
    setScale: (newScale) => set({ scale: newScale, fontScale: newScale }),
    setGamepadScale: () => get().setScale(exports.UnboaredScale.gamepad),
    setScreenScale: () => get().setScale(exports.UnboaredScale.screen),
    toggleScale: () => get().setScale(get().scale === exports.UnboaredScale.screen ? exports.UnboaredScale.gamepad : exports.UnboaredScale.screen)
}));
const useScreenScale = () => {
    const { setScreenScale } = (0, exports.useScale)();
    (0, react_1.useEffect)(() => {
        setScreenScale();
    }, []);
};
exports.useScreenScale = useScreenScale;
const useGamepadScale = () => {
    const { setGamepadScale } = (0, exports.useScale)();
    (0, react_1.useEffect)(() => {
        setGamepadScale();
    }, []);
};
exports.useGamepadScale = useGamepadScale;
//# sourceMappingURL=scale.js.map